import styled from 'styled-components'
import { Panel, Theme } from '@pga/pga-component-library'

const { media } = Theme

export const EventCard = styled(Panel)`
  margin-right: 80px;
  display: flex;
  flex-direction: column;
  @media(min-width: 992px) {
    margin-top: ${props => props.showHeaderImage ? '-35px' : '0px'};
  }
  @media(max-width: 991.98px) {
    box-shadow: none;
    margin-bottom: 0;
    padding: 30px 0;
  }
`

export const RowWrapper = styled.div`
  display: flex;
  align-items: baseline;
  line-height: 1;
`

export const CardRow = styled.div`
  display: flex;
  width: 100%;
  @media(max-width: 575.98px) {
    flex-direction: column;
  }
  @media (min-width: 992px) {
    justify-content: space-between;
  }
  @media (min-width: 1200px) {
    margin-right: 1.5rem;
  }
`

export const HeaderImage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background-image: ${props => `url('${props.img}')`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 400px;
  color: ${Theme.colors.white};
  ${media.mdDown} {
    height: 305px;
    span {
      display: none;
    }
  }
  ${media.smDown} {
    height: 205px;
  }
  ${media.mdOnly} {
    height: 365px;
  }
`

export const ItemRow = styled.div`
  @media (max-width: 575.98px) {
    margin-top: ${props => props.idx % 2 === 0 ? '0px' : '20px'};
  }
  @media (min-width: 576px) and (max-width: 991.98px) { 
    margin-right: ${props => props.idx % 2 === 0 ? '20px' : '0px'};
  }
`

export const DetailRowWrapper = styled.div`
  display: flex;
  align-items: baseline;
  width: 100%;
`

export const TitleWrapper = styled.div`
  background-color: ${Theme.colors.lightgrey};
`
